// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Try multiple variable names to find the right one
const SUPABASE_URL = 
  import.meta.env.VITE_SUPABASE_URL || 
  import.meta.env.VITE_SUPABASE_PROJECT_URL ||
  import.meta.env.SUPABASE_URL;

const SUPABASE_KEY = 
  import.meta.env.VITE_SUPABASE_ANON_KEY || 
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_KEY ||
  import.meta.env.SUPABASE_KEY;

// Debug: Show what we found
console.log('=== SUPABASE CLIENT DEBUG ===');
console.log('Supabase URL:', SUPABASE_URL ? 'Found ✅' : 'Missing ❌');
console.log('Supabase Key:', SUPABASE_KEY ? 'Found ✅' : 'Missing ❌');

// Show the actual values (first/last few characters only for security)
if (SUPABASE_URL) {
  console.log('URL value:', SUPABASE_URL);
  console.log('URL type:', typeof SUPABASE_URL);
  console.log('URL length:', SUPABASE_URL.length);
}

if (SUPABASE_KEY) {
  console.log('Key starts with:', SUPABASE_KEY.substring(0, 10) + '...');
  console.log('Key ends with:', '...' + SUPABASE_KEY.substring(SUPABASE_KEY.length - 10));
  console.log('Key type:', typeof SUPABASE_KEY);
  console.log('Key length:', SUPABASE_KEY.length);
}

console.log('=== END DEBUG ===');

if (!SUPABASE_URL) {
  console.error('❌ VITE_SUPABASE_URL is not set in Vercel Environment Variables');
  throw new Error('Missing VITE_SUPABASE_URL environment variable');
}

if (!SUPABASE_KEY) {
  console.error('❌ Supabase key is not set. Tried these variable names:');
  console.error('  - VITE_SUPABASE_ANON_KEY');
  console.error('  - VITE_SUPABASE_PUBLISHABLE_KEY');
  console.error('  - VITE_SUPABASE_KEY');
  console.error('Check Vercel → Settings → Environment Variables');
  throw new Error('Missing Supabase key environment variable');
}

// Additional validation
const urlStr = String(SUPABASE_URL).trim();
const keyStr = String(SUPABASE_KEY).trim();

console.log('About to create Supabase client...');
console.log('URL (trimmed):', urlStr);
console.log('Key (trimmed first 10):', keyStr.substring(0, 10) + '...');

// Import the supabase client like this:
// import { supabase } from "@/integrations/client";

export const supabase = createClient<Database>(urlStr, keyStr, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

console.log('✅ Supabase client created successfully!');
